module.exports = __webpack_public_path__ + "assets/img/chef-7.04d66443.jpg";